import type { MenuGroup } from './menu';

/** Pilot entry inherits an existing server grant; the legacy link stays available.
 * The API independently enforces the governing /documents permission. */
export function withDocumentsEntry(groups: MenuGroup[]): MenuGroup[] {
  if (groups.some((group) => group.items.some((item) => item.url === '/documents-v2')))
    return groups;
  return groups.map((group) => {
    const source = group.items.find((item) => item.url === '/legacy/documents');
    if (!source) return group;
    return {
      ...group,
      items: [
        ...group.items,
        {
          ...source,
          id: -60,
          labelKey: 'WTK_DOCUMENTS_LIVE_MENU',
          url: '/documents-v2',
          app: 'portal-v2',
          internal: true,
        },
      ],
    };
  });
}
